document.addEventListener('DOMContentLoaded', function () {
    let header = document.querySelector('.maier-header');
    let headerMenu = document.querySelector('.maier-header-menu');

    if (null === headerMenu) {
        return;
    }

    let headerMenuPositionTop = headerMenu.offsetTop;

    function initStickyHeader(element, elementOffsetTop) {
        let scrollOffset = 187;

        if (header.classList.contains('sticky')) {
            scrollOffset = 0;
        }

        if (window.pageYOffset >= elementOffsetTop + scrollOffset) {
            element.classList.add('sticky');
        } else {
            element.classList.remove('sticky');
        }
    };

    window.addEventListener('scroll', function (event) {
        initStickyHeader(header, headerMenuPositionTop);
    }, {passive: true});
})